import React from 'react';
import MagicForm from '../../../../../Components/Form/MagicForm';
import { useAppContext } from '../../../../../Services/AppContext';
import { caseTypeDetailLatamScheme } from './Latam/CaseTypeDetailLatam';
import { caseTypeDetailDefaultScheme } from './Default/CaseTypeDetailDefault';
import { SelectValue } from '../../../../../Components/Base/Select/Select';

export interface CaseTypeDetailFormValues {
	caseTypeId?: string;
	parentCaseTypeId: SelectValue;
	label: string;
	canOrderImmediate: string;
	canBook: string;
	canBookOnline?: boolean;
	canBookOnSite?: boolean;
	eventInterval?: string;
	hiddenForPatient: string;
	isPayed: string;
	price?: string;
	isWithDoc: string;
	docId?: string;
	docName?: string;
	docRequired?: string;
	isWithAnswer: string;
	answerId?: string;
	answerName?: string;
	answerRequired?: string;
	notificationCase?: string;
	notificationBook?: string;
	code?: string;
	setupForMonitoringCenter?: string;
	isEditable?: boolean;
	labelTranslations?: Record<string, string>;
	vatRate?: SelectValue;
}

interface Props {
	onSuccess: (values: CaseTypeDetailFormValues) => void;
	onRemove: () => void;
	workplaceId: string;
	defaultValues?: CaseTypeDetailFormValues;
	isOnlyOneRoot: boolean;
	caseTypeId?: string;
}

const CaseTypeDetailForm: React.FC<Props> = ({
	onSuccess,
	defaultValues,
	onRemove,
	isOnlyOneRoot,
	caseTypeId,
}) => {
	const { globalTemplate } = useAppContext();

	let formScheme = caseTypeDetailDefaultScheme(
		defaultValues?.isEditable,
		isOnlyOneRoot,
		caseTypeId,
	);

	if (['peru', 'ecuador', 'mexico', 'colombia'].includes(globalTemplate)) {
		formScheme = caseTypeDetailLatamScheme(
			defaultValues?.isEditable,
			isOnlyOneRoot,
			caseTypeId,
		);
	}

	return (
		<MagicForm
			formScheme={formScheme}
			onSubmit={onSuccess}
			defaultValues={defaultValues}
			removeButton={{
				onRemove,
			}}
		/>
	);
};

export default CaseTypeDetailForm;
